<template>
  <div class="columns">
    <div class="column" style="text-align:left;">
      <label class="label">Preiserhöhung für Zeitraum in %</label>
      <input type="number" min=0 max=100 v-model="priceRise" placeholder="Beschreibung einfügen"/>
    </div>
    <div class="column" style="text-align:left;">
      <label class="label">Angebots-Hinweis für Zeitraum</label>
<!--      <VueTrix maxlength="255" v-model="offerTextInIntervall" placeholder="Beschreibung einfügen"/>-->
      <textarea maxlength="255" v-model="offerTextInIntervall" placeholder="Beschreibung einfügen" style="width: 300px; height: 80px;"></textarea>
    </div>
  </div>
</template>

<script>
import VueTrix from "vue-trix";

export default {
  props: ['item'],
  components: {VueTrix},
  data() {
    return {
      priceRise: 0,
      offerTextInIntervall: "",
      actionId: null,
    }
  },
  watch: {
    priceRise: {
      handler: "sendActionData"
    },
    offerTextInIntervall: {
      handler: "sendActionData"
    },
  },
  mounted() {
    // modify action
    if (this.item && this.item.actions) {
      this.item = this.item.actions[0]
      this.priceRise = this.item.data.priceRise;
      this.offerTextInIntervall = this.item.data.offerTextInIntervall;
      if (this.item.id) {
        this.actionId = this.item.id;
      }
      console.log('Component action show text.');
    }
  },
  methods: {
    sendActionData: function () {
      console.log('sendActionData')
      let actionData = {
        type: 2, data: {
          offerTextInIntervall: this.offerTextInIntervall,
          priceRise: this.priceRise,
        }
      }
      if (this.actionId) {
        actionData.id = this.actionId
      }
      this.$emit('setActionData', actionData)
    },
  },
}

</script>
